import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    IconButton,
    TextField,
    Typography,
  } from "@mui/material";
  import React, { useState } from "react";

  import { useForm } from "react-hook-form";
import { WSIcons } from "../../../commonFunctions/iIcons";
import WSTextField from "../../../Components/TextBox/WSTextBox";
import WSTextAreaField from "../../../Components/WSTextArea/WSTextArea";
import { Grade } from "@mui/icons-material";
  
  export const NoSale: React.FC<any> = React.memo(
    ({ open, onClose }) => {
      const { control, register,handleSubmit } = useForm();
    
      const onSubmit = async (data: any) => {
          debugger;
          console.log("onsubmit===>", data); // You can perform any action with the submitted data here
        };
      
        return (
          <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <form onSubmit={handleSubmit(onSubmit)}>
            <Grid sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', bgcolor: '#2E7D32', color: 'white', px: 2, py: 1 }}>
              <DialogTitle sx={{ color: 'white', p: 0 }}>Enter Remark / Reason</DialogTitle>
              <IconButton onClick={onClose} sx={{ color: 'white' }}>
                <WSIcons.CloseIcon />
              </IconButton>
            </Grid>
      
            {/* Content */}
            <DialogContent sx={{ px: 3, pt: 2 }}>
            <WSTextAreaField
                  label={"Enter Reason"}
                  id={"remark"}
                  name={"remark"}
                  control={control}
                  rules={{ required: false }}
                  rows={3}
                />     
      
             
            </DialogContent>
      
            {/* Actions */}
            <DialogActions sx={{ bgcolor: '#424242', justifyContent: 'flex-end', px: 3, py: 2 }}>
              <Button onClick={handleSubmit(onSubmit)} variant="contained" sx={{ bgcolor: '#2E7D32', color: 'white', textTransform: 'none', fontSize: '1rem' }}>
                Finish
              </Button>
            </DialogActions>
            </form>
          </Dialog>
        );
      })
  